import React  from 'react';
import { EuiBadge, EuiFlexItem, EuiListGroup } from '@elastic/eui';

export const Listado = (props) =>{

  let {listOptions}=props;

  const renderOptions = () =>{
    return listOptions.map((o)=>{
      return o;
    })
  }

if(listOptions)
{
  return listOptions.length>0 ? (
    <EuiListGroup className={props.className && props.className}>
      {renderOptions()}
    </EuiListGroup>
  ):(<EuiFlexItem grow={false} key="danger">
  <EuiBadge color="danger">Sin datos</EuiBadge>
  </EuiFlexItem>)
}else{return null}

}